export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/v1/auth/native/login',
    SIGNUP: '/v1/auth/native/signup',
    REFRESH: '/v1/auth/refresh',
    ME: '/v1/auth/me',
    LOGOUT: '/v1/auth/logout',
  },
  USERS: {
    LIST: '/v1/users',
    CREATE: '/v1/users',
    GET: (id: string) => `/v1/users/${id}`,
    UPDATE: (id: string) => `/v1/users/${id}`,
    DELETE: (id: string) => `/v1/users/${id}`,
  },
  ORGS: {
    LIST: '/v1/orgs',
    CREATE: '/v1/orgs',
    GET: (id: string) => `/v1/orgs/${id}`,
    UPDATE: (id: string) => `/v1/orgs/${id}`,
    DELETE: (id: string) => `/v1/orgs/${id}`,
  },
  TOKENS: {
    BALANCE: '/v1/tokens/balance',
    REFILL: '/v1/tokens/refill',
    TRANSACTIONS: '/v1/tokens/transactions',
  },
  AUDIT: {
    LIST: '/v1/audit',
    EXPORT: '/v1/audit/export',
  },
  ANALYTICS: {
    USAGE: '/v1/analytics/usage',
    RETENTION: '/v1/analytics/retention',
    OVERVIEW: '/v1/analytics/overview',
  },
  AGENTS: {
    LIST: '/v1/agents',
    CREATE: '/v1/agents',
    GET: (id: string) => `/v1/agents/${id}`,
    APPROVE: (id: string) => `/v1/agents/${id}/approve`,
    DELETE: (id: string) => `/v1/agents/${id}`,
  },
} as const

export const USER_ROLES = {
  PLATFORM_ADMIN: 'platform_admin',
  ORG_ADMIN: 'org_admin',
  USER: 'user',
} as const

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  STATS: '/stats',
  USERS: '/users',
  ORGS: '/orgs',
  TOKENS: '/tokens',
  AGENTS: '/agents',
  AUDIT: '/audit',
} as const
